import React from "react";
import { formatCellText, getTrendDirection, toneForTrend } from "./duOddsUtils";

const TrendIcon = ({ trend }) => {
  const dir = getTrendDirection(trend);
  if (!dir) return null;

  return (
    <span
      className={`ml-0.5 text-[10px] motion-reduce:animate-none animate-[pulse_0.5s_ease-in-out_3] ${
        dir === "up" ? "du-odds-up" : "du-odds-down"
      }`}
    >
      {dir === "up" ? "▲" : "▼"}
    </span>
  );
};

export default function DuOdds3({
  left,
  middle,
  right,
  leftTrend,
  middleTrend,
  rightTrend,
}) {
  return (
    <div className="grid grid-cols-3 gap-0">
      <div
        className={`min-w-[40px] rounded-[10px] text-center text-sm font-medium leading-6 transition hover:bg-white/10 md:min-w-[46px] ${toneForTrend(
          leftTrend,
        )}`}
      >
        {formatCellText(left)}
        <TrendIcon trend={leftTrend} />
      </div>

      <div
        className={`min-w-[40px] rounded-[10px] text-center text-sm font-medium leading-6 transition hover:bg-white/10 md:min-w-[46px] ${toneForTrend(
          middleTrend,
        )}`}
      >
        {formatCellText(middle)}
        <TrendIcon trend={middleTrend} />
      </div>

      <div
        className={`min-w-[40px] rounded-[10px] text-center text-sm font-medium leading-6 transition hover:bg-white/10 md:min-w-[46px] ${toneForTrend(
          rightTrend,
        )}`}
      >
        {formatCellText(right)}
        <TrendIcon trend={rightTrend} />
      </div>
    </div>
  );
}

